import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	owner: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	workItems: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	scorecardInfo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	componentReadiness: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ownerTeamAdded: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	repositoryAdded: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionAdded: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	buildSuccessRate: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pullRequestCycleTime: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	projectAdded: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	securityMetrics: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	softwareQuality: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	openJiraIssues: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	devOpsHealth: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	openBugs: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	qualityGateConditions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	openCriticalSeverityVulnerabilities: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	openHighSeverityVulnerabilities: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	plusOne: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	plusThree: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	projectAddedGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	owner: {
		id: 'compass-repository-card.owner',
		defaultMessage: 'Owner',
		description: 'Shown to the user on the compass repository card.',
	},
	workItems: {
		id: 'compass-repository-card.work-items',
		defaultMessage: 'Work items',
		description:
			'Shown to the user on the Compass repository card in the completed actions at the bottom.',
	},
	scorecardInfo: {
		id: 'compass-repository-card.scorecard-info',
		defaultMessage:
			'Use this scorecard in Compass to ensure component details are ready for development teams to reference in the catalog.',
		description:
			'Shown to the user on the Compass repository card when they click on the info icon beside a scorecard name.',
	},
	componentReadiness: {
		id: 'compass-repository-card.component-readiness',
		defaultMessage: 'Component readiness',
		description:
			'Shown to the user on the Compass repository card in the completed actions at the bottom.',
	},
	ownerTeamAdded: {
		id: 'compass-repository-card.owner-team-added',
		defaultMessage: 'Owner team added',
		description:
			'Shown to the user on the Compass repository card in the completed actions at the bottom.',
	},
	repositoryAdded: {
		id: 'compass-repository-card.repository-added',
		defaultMessage: 'Repository added',
		description:
			'Shown to the user on the Compass repository card in the completed actions at the bottom.',
	},
	descriptionAdded: {
		id: 'compass-repository-card.description-added',
		defaultMessage: 'Description added',
		description:
			'Shown to the user on the Compass repository card in the completed actions at the bottom.',
	},
	buildSuccessRate: {
		id: 'compass-repository-card.build-success-rate',
		defaultMessage: 'Build success rate',
		description:
			'Shown to the user on the Compass repository card in the completed actions at the bottom.',
	},
	pullRequestCycleTime: {
		id: 'compass-repository-card.pull-request-cycle-time',
		defaultMessage: 'Pull request cycle time',
		description:
			'Shown to the user on the Compass repository card in the completed actions at the bottom.',
	},
	projectAdded: {
		id: 'compass-repository-card.project-added',
		defaultMessage: 'Project added',
		description:
			'Shown to the user on the Compass repository card in the completed actions at the bottom.',
	},
	securityMetrics: {
		id: 'compass-repository-card.security-metrics',
		defaultMessage: 'Security metrics',
		description:
			'Shown to the user on the Compass repository card in the completed actions at the bottom.',
	},
	softwareQuality: {
		id: 'compass-repository-card.software-quality',
		defaultMessage: 'Software quality',
		description:
			'Shown to the user on the Compass repository card in the completed actions at the bottom.',
	},
	openJiraIssues: {
		id: 'compass-repository-card.open-jira-issues',
		defaultMessage: 'Open Jira work items',
		description:
			'Shown to the user on the Compass repository card in the completed actions at the bottom.',
	},
	devOpsHealth: {
		id: 'compass-repository-card.devops-health',
		defaultMessage: 'DevOps health',
		description:
			'Shown to the user on the Compass repository card in the completed actions at the bottom.',
	},
	openBugs: {
		id: 'compass-repository-card.open-bugs',
		defaultMessage: 'Open bugs',
		description:
			'Shown to the user on the Compass repository card in the completed actions at the bottom.',
	},
	qualityGateConditions: {
		id: 'compass-repository-card.quality-gate-conditions',
		defaultMessage: 'Quality gate conditions',
		description:
			'Shown to the user on the Compass repository card in the completed actions at the bottom.',
	},
	openCriticalSeverityVulnerabilities: {
		id: 'compass-repository-card.open-critical-severity-vulnerabilities',
		defaultMessage: 'Open critical severity vulnerabilities',
		description:
			'Shown to the user on the Compass repository card in the completed actions at the bottom.',
	},
	openHighSeverityVulnerabilities: {
		id: 'compass-repository-card.open-high-severity-vulnerabilities',
		defaultMessage: 'Open high severity vulnerabilities',
		description:
			'Shown to the user on the Compass repository card in the completed actions at the bottom.',
	},
	plusOne: {
		id: 'compass-repository-card.plus-one',
		defaultMessage: '+1',
		description:
			'Shown to the user on the Compass repository card in the completed actions at the bottom.',
	},
	plusThree: {
		id: 'compass-repository-card.plus-three',
		defaultMessage: '+3',
		description:
			'Shown to the user on the Compass repository card in the completed actions at the bottom.',
	},
	projectAddedGalaxia: {
		id: 'compass-repository-card.project-added-galaxia',
		defaultMessage: 'Space added',
		description:
			'Shown to the user on the Compass repository card in the completed actions at the bottom.',
	},
});
